// DO NOT EDIT -- generated from fs/services/matchmaker/matchmaker.proto

import * as protobuf from '../../../google/protobuf';
import * as schema from '../../shared/schema';
import * as signalstudio from '../../api/signalstudio';

export namespace Signal {

  export const UpsertSignalEndpoint = "/grpc/matchmaker.Signal/UpsertSignal";
  /**
   * UpsertSignal creates a new signal or updates an existing signal. If the signal ID is empty, a new signal will be
   * created. Otherwise, the existing signal with the same ID will be updated. An error will be returned if the signal
   * does not exist. Signals are created in an uncommitted state and must be updated at least once to be considered
   * committed and thus visible to the rest of the system.
   */
  export function UpsertSignal(sender: (req: UpsertSignalRequest, endpoint: string) => Promise<UpsertSignalResponse>, req: UpsertSignalRequest): { promise: () => Promise<UpsertSignalResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpsertSignalEndpoint),
      endpoint: UpsertSignalEndpoint
    };
  }

  export const DeleteSignalEndpoint = "/grpc/matchmaker.Signal/DeleteSignal";
  export function DeleteSignal(sender: (req: DeleteSignalRequest, endpoint: string) => Promise<{}>, req: DeleteSignalRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSignalEndpoint),
      endpoint: DeleteSignalEndpoint
    };
  }

  export const GetAllSignalsEndpoint = "/grpc/matchmaker.Signal/GetAllSignals";
  export function GetAllSignals(sender: (req: GetAllSignalsRequest, endpoint: string) => Promise<GetAllSignalsResponse>, req: GetAllSignalsRequest): { promise: () => Promise<GetAllSignalsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSignalsEndpoint),
      endpoint: GetAllSignalsEndpoint
    };
  }
}

export namespace SignalPublic {

  export const UpsertSignalEndpoint = "/grpc/matchmaker.SignalPublic/UpsertSignal";
  export function UpsertSignal(sender: (req: UpsertSignalRequestPublic, endpoint: string) => Promise<UpsertSignalResponsePublic>, req: UpsertSignalRequestPublic): { promise: () => Promise<UpsertSignalResponsePublic>, endpoint: string } {
    return {
      promise: () => sender(req, UpsertSignalEndpoint),
      endpoint: UpsertSignalEndpoint
    };
  }

  export const DeleteSignalEndpoint = "/grpc/matchmaker.SignalPublic/DeleteSignal";
  export function DeleteSignal(sender: (req: DeleteSignalRequestPublic, endpoint: string) => Promise<{}>, req: DeleteSignalRequestPublic): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSignalEndpoint),
      endpoint: DeleteSignalEndpoint
    };
  }

  export const GetAllSignalsEndpoint = "/grpc/matchmaker.SignalPublic/GetAllSignals";
  export function GetAllSignals(sender: (req: GetAllSignalsRequestPublic, endpoint: string) => Promise<GetAllSignalsResponsePublic>, req: GetAllSignalsRequestPublic): { promise: () => Promise<GetAllSignalsResponsePublic>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSignalsEndpoint),
      endpoint: GetAllSignalsEndpoint
    };
  }
}

export namespace SignalMatcher {

  export const ProcessPageEndpoint = "/grpc/matchmaker.SignalMatcher/ProcessPage";
  /**
   * ProcessPage is stateful and processes a complete cooked page. The page must be complete since it will be used to
   * "replace" the counterpart in the state instead of "merge". After the page is processed in the state, all the
   * matched signals in the org as the result of the processing will be returned. There is no deduplication so that
   * the same matched signal could be repeatedly returned. Somewhere in the downstream should deduplicate. The pages
   * in an org can be processed in any order, though late arrival pages after some threshold might be ignored.
   */
  export function ProcessPage(sender: (req: ProcessPageRequest, endpoint: string) => Promise<{}>, req: ProcessPageRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ProcessPageEndpoint),
      endpoint: ProcessPageEndpoint
    };
  }

  export const MatchUserEndpoint = "/grpc/matchmaker.SignalMatcher/MatchUser";
  /**
   * MatchUser matches the specified user with any of the user scope signals in the org. This endpoint is stateless
   * and does not affect the state of ProcessPage, i.e., no side effect.
   */
  export function MatchUser(sender: (req: MatchUserRequest, endpoint: string) => Promise<MatchResponse>, req: MatchUserRequest): { promise: () => Promise<MatchResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MatchUserEndpoint),
      endpoint: MatchUserEndpoint
    };
  }

  export const MatchSessionEndpoint = "/grpc/matchmaker.SignalMatcher/MatchSession";
  /**
   * MatchSession matches the specified session with any of the session scope signals in the org. This endpoint is
   * stateless and does not affect the state of ProcessPage, i.e., no side effect.
   */
  export function MatchSession(sender: (req: MatchSessionRequest, endpoint: string) => Promise<MatchResponse>, req: MatchSessionRequest): { promise: () => Promise<MatchResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MatchSessionEndpoint),
      endpoint: MatchSessionEndpoint
    };
  }
}

export interface UpsertSignalRequest {
  orgId: string;
  signal: signalstudio.Signal | null;
  maxSignals: number;
}

export interface UpsertSignalResponse {
  signal: signalstudio.Signal | null;
}

export interface DeleteSignalRequest {
  orgId: string;
  signalId: protobuf.int64;
}

export interface GetAllSignalsRequest {
  orgId: string;
}

export interface GetAllSignalsResponse {
  signals: signalstudio.Signal[];
}

export interface UpsertSignalRequestPublic {
  signal: signalstudio.Signal | null;
}

export interface UpsertSignalResponsePublic {
  signal: signalstudio.Signal | null;
}

export interface DeleteSignalRequestPublic {
  signalId: protobuf.int64;
}

export interface GetAllSignalsRequestPublic {
}

export interface GetAllSignalsResponsePublic {
  signals: signalstudio.Signal[];
}

export interface ProcessPageRequest {
  pageArgs: schema.PageArgsProto | null;
}

export interface MatchUserRequest {
  orgId: string;
  userId: protobuf.int64;
}

export interface MatchSessionRequest {
  orgId: string;
  userId: protobuf.int64;
  sessionId: protobuf.int64;
}

export interface MatchResponse {
  processedSessions: number;
  processedPages: number;
  uniqueMatches: signalstudio.SignalMatch[];
}

/**
 * MatchState is the storage format of the page states used by the sequence matcher. Note that since the number of
 * steps in a sequence is likely to be small, e.g., <= 10, there is no need to flatten offsets from all steps into a
 * single int64 slice. A test shows that flattening only has 0.2% space saving for 10*1000 offsets with 18764 bytes.
 */
export interface MatchState {
  start: protobuf.timestamp | null;
  steps: MatchState.Step[];
  negationOffsets: protobuf.int64[];
}

/**
 * MatchState is the storage format of the page states used by the sequence matcher. Note that since the number of
 * steps in a sequence is likely to be small, e.g., <= 10, there is no need to flatten offsets from all steps into a
 * single int64 slice. A test shows that flattening only has 0.2% space saving for 10*1000 offsets with 18764 bytes.
 */
export namespace MatchState {
  export interface Step {
    offsets: protobuf.int64[];
  }
}

export interface PropertyState {
  steps: PropertyState.Step[];
}

export namespace PropertyState {
  export interface Step {
    properties: protobuf.Struct[];
  }
}

/**
 * EventProperty is an enumeration of all properties available for downstream property mapping.
 * Many of these have corresponding fields in fs/api/eventstream/events.proto which describes them with comments.
 */
export enum EventProperty {
  EVENT_PROPERTY_UNKNOWN = 0,
  EVENT_PROPERTY_DEVICE_ID = 1,
  EVENT_PROPERTY_SESSION_ID = 2,
  EVENT_PROPERTY_SOURCE_TYPE = 3,
  EVENT_PROPERTY_EVENT_TIME = 4,
  EVENT_PROPERTY_EVENT_TYPE = 29,
  EVENT_PROPERTY_TARGET_TEXT = 5,
  EVENT_PROPERTY_URL = 6,
  EVENT_PROPERTY_REFERER_URL = 7,
  EVENT_PROPERTY_IP_ADDRESS = 8,
  EVENT_PROPERTY_COUNTRY = 9,
  EVENT_PROPERTY_REGION = 10,
  EVENT_PROPERTY_CITY = 11,
  EVENT_PROPERTY_DEVICE_MANUFACTURER = 12,
  EVENT_PROPERTY_DEVICE_MODEL = 13,
  EVENT_PROPERTY_DEVICE_OPERATING_SYSTEM = 14,
  EVENT_PROPERTY_DEVICE_OS_VERSION = 15,
  EVENT_PROPERTY_UA_BROWSER = 16,
  EVENT_PROPERTY_UA_BROWSER_VERSION = 17,
  EVENT_PROPERTY_UA_DEVICE = 27,
  EVENT_PROPERTY_UA_OPERATING_SYSTEM = 28,
  EVENT_PROPERTY_APP_SCREEN_NAME = 18,
  EVENT_PROPERTY_APP_BUILD_VARIANT = 19,
  EVENT_PROPERTY_APP_ID = 20,
  EVENT_PROPERTY_APP_NAME = 21,
  EVENT_PROPERTY_APP_VERSION = 22,
  EVENT_PROPERTY_PAGE_NAME = 34,
  EVENT_PROPERTY_ELEMENT_NAME = 36,
  /** The given name of a custom event */
  EVENT_PROPERTY_CUSTOM_NAME = 23,
  /** All custom properties sent with a custom event. Persisted value is a map of property name to value. */
  EVENT_PROPERTY_CUSTOM_PROPERTIES = 24,
  /** The name of the most specific matching defined event */
  EVENT_PROPERTY_DEFINED_NAME = 25,
  /** The time when the event reached FS servers */
  EVENT_PROPERTY_INGESTION_TIME = 26,
  /** All extracted element properties available on an event. */
  EVENT_PROPERTY_EXTRACTED_ELEMENT_PROPERTIES = 30,
  /** URLs linking into FSTA */
  EVENT_PROPERTY_APP_URL_SESSION = 31,
  EVENT_PROPERTY_APP_URL_USER = 32,
  EVENT_PROPERTY_APP_URL_EVENT = 33,
  /** All page vars denormalized onto an event. Persisted value is a map of name to value. */
  EVENT_PROPERTY_PAGE_PROPERTIES = 35,
  /** The session ID generated by the capture client. Takes the form <user_id>:<session_id>. */
  EVENT_PROPERTY_CLIENT_SESSION_ID = 37,
  /** The session ID explicitly set by the client via the events API */
  EVENT_PROPERTY_SESSION_UID = 38,
  EVENT_PROPERTY_USER_EMAIL = 39,
  EVENT_PROPERTY_USER_DISPLAY_NAME = 40,
  EVENT_PROPERTY_USER_UID = 41,
  EVENT_PROPERTY_USER_PROPERTIES = 42,
  EVENT_PROPERTY_PREDICTIONS = 43
}

export interface FindSequenceTask {
  pageArgs: schema.PageArgsProto | null;
  signal: signalstudio.Signal | null;
}
